<template>
  <AppLayout>
    <router-view :key="router.currentRoute.value.fullPath" />
  </AppLayout>
</template>
<script setup>
import { onMounted, onUnmounted } from 'vue';
import router from '@/router/index';
import { useMenuState } from '@/composables/useMenuState';

const { initializeMenu } = useMenuState();

// Função nomeada para permitir remoção correta do listener
const handleResize = () => {
  initializeMenu();
};

onMounted(() => {
  initializeMenu();

  // Monitora o redimensionamento da janela para lidar com o menu responsivo.
  window.addEventListener('resize', handleResize);
});

onUnmounted(() => {
  // Cleanup: remove o listener para evitar vazamento de memória
  window.removeEventListener('resize', handleResize);
});
</script>
